import React, { useCallback, useEffect } from "react"
import { trim } from "lodash-es"

import { useTranslation } from "@/locales"
import Reg from "@/utils/reg"
import Input from "../Input"

import styles from "./index.module.less"

interface Props {
    scene: string
    value: string
    onChange: (value: string) => void
    onKeyUp: (e: React.KeyboardEvent<HTMLInputElement>) => void
}

const InputAccount: React.FC<Props> = (props) => {
    const { scene, value, onChange, onKeyUp } = props
    const { t } = useTranslation()

    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = trim(e.target.value)
            if (scene === "account" || Reg.isPhoneInput.test(value)) {
                onChange(value)
            }
        },
        [scene, onChange]
    )

    useEffect(() => {
        if (scene === "smsCode" && !Reg.isPhoneInput.test(value)) {
            onChange("")
        }
    }, [scene, onChange, value])

    return (
        <Input
            type="text"
            autoComplete="off"
            className={styles.account}
            value={value}
            onChange={handleChange}
            onKeyUp={onKeyUp}
            placeholder={
                scene === "account"
                    ? t("login.placeholder.account")
                    : t("login.placeholder.phone")
            }
        />
    )
}

export default InputAccount
